import { render, staticRenderFns } from "./BLPost.vue?vue&type=template&id=079fa724&scoped=true"
import script from "./BLPost.vue?vue&type=script&lang=js"
export * from "./BLPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079fa724",
  null
  
)

export default component.exports